/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import { Dialog, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import LogoCorreios from '../../../../assets/images/logoCorreios.png';
import { ButtonPrimary } from '../../../../shared/components';
import { useGetCorreiosCredentials } from '../../hooks/use-get-correios-credentials';
import { useSetCorreiosCredentials } from '../../hooks/use-set-correios-credentials';
import { BootstrapDialogTitle } from '../BootstrapDialogTitle';
import { DivActions, ContentModal } from '../styles';

export function ModalCorreios({ open, handleClose, storeId }) {
  const { getCorreiosCredentials, credentials, setCredentials } =
    useGetCorreiosCredentials();
  const { setCorreiosCredentials } = useSetCorreiosCredentials();

  useEffect(() => {
    if (open) {
      getCorreiosCredentials(storeId);
    }
  }, [open]);

  return (
    <Dialog fullWidth={600} open={open} onClose={handleClose}>
      <BootstrapDialogTitle onClose={handleClose} logo={LogoCorreios}>
        Linkar conta com Correios
      </BootstrapDialogTitle>
      <ContentModal>
        <TextField
          id="correiosId"
          label="ID do correio *"
          variant="outlined"
          fullWidth
          value={credentials.correiosId}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosId: e.target.value.trim(),
            })
          }
        />
        <TextField
          id="passwordC"
          label="Senha correios *"
          variant="outlined"
          fullWidth
          value={credentials.correiosPassword}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosPassword: e.target.value.trim(),
            })
          }
        />
        <TextField
          id="administrativeCode"
          label="Código administrativo *"
          variant="outlined"
          fullWidth
          value={credentials.correiosAdministrativeCode}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosAdministrativeCode: e.target.value.trim(),
            })
          }
        />
        <TextField
          id="postageCard"
          label="Número do contrato *"
          variant="outlined"
          fullWidth
          value={credentials.correiosContract}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosContract: e.target.value.trim(),
            })
          }
        />
        <TextField
          id="serviceCode"
          label="Código do serviço *"
          variant="outlined"
          fullWidth
          value={credentials.correiosServiceCode}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosServiceCode: e.target.value.trim(),
            })
          }
        />
        <TextField
          id="correiosPostageCard"
          label="Código postal *"
          variant="outlined"
          fullWidth
          value={credentials.correiosPostageCard}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              correiosPostageCard: e.target.value.trim(),
            })
          }
        />
      </ContentModal>
      <DivActions>
        <ButtonPrimary.Normal
          width="100%"
          label="LINKAR CONTA"
          onClick={async () => {
            await setCorreiosCredentials({ storeId, credentials });
            handleClose();
          }}
        />
      </DivActions>
    </Dialog>
  );
}

ModalCorreios.propTypes = {
  storeId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
